<template>
  <main class="reviews__wrapper">
    <div class="reviews__header">
      <div :class="{ active: selectedBlock === 'reviews' }" @click="selectedBlock = 'reviews'">
        Reviews
      </div>
      <div :class="{ active: selectedBlock === 'add' }" @click="selectedBlock = 'add'">
        Add Review
      </div>
    </div>
    <template v-if="selectedBlock === 'reviews'">
      <Loader v-if="loading" />
      <div class="reviews" v-else>
        <div v-for="review in reviews" :key="review.id" class="review">
          <div class="review-delete" @click="deleteReview(review.id)">x</div>
          <div class="review-header">
            <h2>{{ review.username }}</h2>
            <p>
              <svg
                viewBox="0 0 16 16"
                fill="currentColor"
                class="icon_icon__ECGRl"
                xmlns="http://www.w3.org/2000/svg"
                width="14px"
                height="14px"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.404 1.904A6.5 6.5 0 0 1 14.5 6.5v.01c0 .194 0 .396-.029.627l-.004.03-.023.095c-.267 2.493-1.844 4.601-3.293 6.056a18.723 18.723 0 0 1-2.634 2.19 11.015 11.015 0 0 1-.234.154l-.013.01-.004.002h-.002L8 15.25l-.261.426h-.002l-.004-.003-.014-.009a13.842 13.842 0 0 1-.233-.152 18.388 18.388 0 0 1-2.64-2.178c-1.46-1.46-3.05-3.587-3.318-6.132l-.003-.026v-.068c-.025-.2-.025-.414-.025-.591V6.5a6.5 6.5 0 0 1 1.904-4.596ZM8 15.25l-.261.427.263.16.262-.162L8 15.25Zm-.002-.598a17.736 17.736 0 0 0 2.444-2.04c1.4-1.405 2.79-3.322 3.01-5.488l.004-.035.026-.105c.018-.153.018-.293.018-.484a5.5 5.5 0 0 0-11 0c0 .21.001.371.02.504l.005.035v.084c.24 2.195 1.632 4.109 3.029 5.505a17.389 17.389 0 0 0 2.444 2.024Z"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM4.5 6.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z"
                ></path>
              </svg>
              {{ review.country }}
            </p>
          </div>
          <div class="review-content">
            <div class="review-content__stars">
              <svg
                v-for="i in 5"
                :key="i"
                class="star"
                :class="{ active: i <= review.grade }"
                width="38"
                height="37"
                viewBox="0 0 38 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.1468 2.78116C17.0449 0.0172243 20.9551 0.01722 21.8532 2.78115L24.1638 9.8926C24.5654 11.1287 25.7173 11.9656 27.017 11.9656H34.4944C37.4006 11.9656 38.6089 15.6844 36.2578 17.3926L30.2084 21.7877C29.1569 22.5517 28.717 23.9058 29.1186 25.1418L31.4292 32.2533C32.3273 35.0172 29.1639 37.3156 26.8127 35.6074L20.7634 31.2123C19.7119 30.4483 18.2881 30.4483 17.2366 31.2123L11.1873 35.6074C8.83614 37.3156 5.6727 35.0172 6.57075 32.2533L8.8814 25.1418C9.28303 23.9058 8.84305 22.5517 7.79159 21.7877L1.74223 17.3926C-0.608913 15.6844 0.599411 11.9656 3.50558 11.9656H10.983C12.2827 11.9656 13.4346 11.1287 13.8362 9.89261L16.1468 2.78116Z"
                  fill="#D9D9D9"
                />
              </svg>
            </div>

            <h2>{{ review.title }}</h2>
            <p>{{ review.text }}</p>
          </div>
        </div>
      </div>

      <div class="pages">
        <p v-for="i in pageCount" :key="i" :class="{ active: i === page }" @click="changePage(i)">
          {{ i }}
        </p>
      </div>
    </template>

    <template v-if="selectedBlock === 'add'">
      <form class="review-add__form">
        <div class="review-add__form__column">
          <div class="review-add__form__field">
            <label for="">Имя автора</label>
            <input type="text" placeholder="Username" v-model="form.username" />
          </div>
          <div class="review-add__form__field">
            <label for="">Страна пользователя</label>
            <input type="text" placeholder="Country (e.g. ru, us)" v-model="form.country" />
          </div>
          <div class="review-add__form__field">
            <label for="">Заголовок отзыва</label>
            <input type="text" placeholder="Title" v-model="form.title" />
          </div>
          <div class="review-add__form__field">
            <label for="">Оценка пользователя</label>
            <select v-model="form.grade">
              <option value="5">5</option>
              <option value="4">4</option>
              <option value="3">3</option>
              <option value="2">2</option>
              <option value="1">1</option>
            </select>
          </div>
          <div class="review-add__form__field">
            <label for="">Дата публикации отзыва</label>
            <input type="date" placeholder="Publish Date" v-model="form.publishDate" />
          </div>
        </div>
        <div class="review-add__form__column">
          <div class="review-add__form__field">
            <label for="">Ссылка на аватарку</label>
            <input type="text" placeholder="Avatar URL" v-model="form.avatarUrl" />
          </div>
          <div class="review-add__form__field">
            <label for="">Язык отзыва</label>
            <select v-model="form.language">
              <option value="ru">Русский</option>
              <option value="en">English</option>
            </select>
          </div>
          <div class="review-add__form__field">
            <label for="">Текст отзыва</label>
            <input type="text" placeholder="Content" v-model="form.text" />
          </div>
          <div class="review-add__form__field">
            <label for="">Источник отзыва</label>
            <select v-model="form.source">
              <option value="vk">VK</option>
              <option value="trustpilot">TrustPilot</option>
            </select>
          </div>
          <div class="review-add__form__field">
            <label for="">Ссылка на отзыв</label>
            <input type="text" placeholder="Review URL" v-model="form.reviewUrl" />
          </div>
        </div>
      </form>
      <div class="review-add__button">
        <p class="error">{{ formError }}</p>
        <button @click="saveReview">Save review</button>
      </div>
    </template>
  </main>
</template>

<script>
import './reviews.scss'

import Loader from '../../components/Loader/Loader'

import cookie from 'vue-cookie'

export default {
  name: 'Reviews',
  components: {
    Loader,
  },
  data() {
    return {
      page: 1,
      pageCount: 1,
      reviews: [],
      loading: false,
      selectedBlock: 'add',
      form: {
        username: '',
        avatarUrl: '',
        publishDate: '',
        grade: 5,
        title: '',
        language: 'ru',
        country: '',
        text: '',
        reviewUrl: '',
        source: 'vk'
      },
      formError: ''
    }
  },
  mounted() {
    this.getReviews()
  },
  methods: {
    async saveReview() {
      this.formError = ''
      const body = {
        username: this.form.username,
        country: this.form.country,
        language: this.form.language,
        grade: parseInt(this.form.grade),
        title: this.form.title,
        text: this.form.text,
        source: this.form.source,
        reviewUrl: this.form.reviewUrl,
        avatarUrl: this.form.avatarUrl,
        publishDate: this.form.publishDate
      }

      const response = await fetch(
        `https://neural-product-support-new.herokuapp.com/api/v2/reviews`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${cookie.get('token')}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }
      )
      const responseBody = await response.json()

      if (responseBody.status) {
        this.form = {
          username: '',
          avatarUrl: '',
          publishDate: '',
          grade: 5,
          title: '',
          language: 'ru',
          country: '',
          text: '',
          reviewUrl: '',
          source: 'vk'
        }
      } else {
        this.formError = responseBody.error
      }
    },
    async getReviews() {
      this.loading = true
      const response = await fetch(
        `https://neural-product-support-new.herokuapp.com/api/v2/reviews?page=${this.page}&count=10`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${cookie.get('token')}`
          }
        }
      )
      const responseBody = await response.json()
      this.loading = false

      if (!responseBody.status) {
        return
      }

      this.pageCount = responseBody.data.pageCount
      this.reviews = responseBody.data.reviews
    },
    async deleteReview(id) {
      this.loading = true
      await fetch(`https://neural-product-support-new.herokuapp.com/api/v2/reviews/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${cookie.get('token')}`
        }
      })

      this.getReviews()
    },
    changePage(page) {
      this.page = page
      this.getReviews()
    }
  }
}
</script>
